import React from 'react';
import { useFormikContext } from 'formik';

import { TranslationKeys } from 'app/translations';

import { ActionButtonStyled, GridStyled } from './RegulationsPanelForm.styles';

type RegulationsPanelFormActionsProps = {
  editable: boolean;
  editing: boolean;
  loading: boolean;
  onStartEditing: () => void;
};

export const RegulationsPanelFormActions = ({
  editable,
  editing,
  loading,
  onStartEditing,
}: RegulationsPanelFormActionsProps) => {
  const { isSubmitting, submitForm, resetForm, dirty } = useFormikContext();

  return (
    <GridStyled item xs={12}>
      {editable && !editing && (
        <ActionButtonStyled
          onClick={onStartEditing}
          messageId={TranslationKeys.button_edit}
          disabled={loading || isSubmitting}
        />
      )}
      {editable && editing && (
        <>
          <ActionButtonStyled
            onClick={resetForm}
            variant={'outlined'}
            messageId={TranslationKeys.button_cancel}
            disabled={!editing || isSubmitting}
          />
          <ActionButtonStyled
            onClick={submitForm}
            messageId={TranslationKeys.button_save}
            disabled={!editing || isSubmitting || !dirty}
          />
        </>
      )}
    </GridStyled>
  );
};
